export const SET_PAGES = 'SET_PAGES'

export const SET_PAGE = 'SET_PAGE'

export const ADD_PAGE = 'ADD_PAGE'

export const SET_RESTORING = 'SET_RESTORING'

export const SET_EXTERNAL_LOGIN = 'SET_EXTERNAL_LOGIN'

export const SET_FLUX = 'SET_FLUX'

export const SET_SCROLL_PERCENT = 'SET_SCROLL_PERCENT'

export const SET_EXISTENT_CONTACT = 'SET_EXISTENT_CONTACT'

export const SET_SURVEY_FINISHED = 'SET_SURVEY_FINISHED'
